'use es6';

import { handleActions } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';
import { CACHE_RESPONDERS } from '../constants/ActionTypes';
const initialState = ImmutableMap();
export default handleActions({
  [CACHE_RESPONDERS]: (state, action) => state.merge(action.payload)
}, initialState);